module.exports = __webpack_public_path__ + "img/emoji-neutral-2x.de82cc92.png";